import cn from './cn';
import en from './en';
import tw from './tw';
import jp from './jp';

export const messages = {
    cn,
    tw,
    en,
    jp,
};
